import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import { Popup } from "@/Common/Components/Modals/Popup";

interface IImportPopupProps {
    className?: string;
    style?: React.CSSProperties
    title?: string;
    isError: boolean;
    messageToDisplay: string;
    closePopupCallback: () => void;
    cancelCallback: () => void;
    continueCallback: () => void;
    warningMessageToDisplay?: string
}

class ImportPopupComponent extends React.Component<IImportPopupProps> {
    public render(): JSX.Element {
        let self = this;
        let title = self.props.title != null ? self.props.title : "";
        let isError = self.props.isError != null ? self.props.isError : false;

        return (
            <div className={self.props.className} style={self.props.style}>
                <Popup cssClass="linkToMyle-popup" draggable={true} title={title} onCloseDelegate={() => self.props.closePopupCallback()}>
                    <div>
                        <div className="flex-container linkToMyle-popup-selectedEmployee" style={{ justifyContent: "flex-start" }}>
                            <div>
                                {self.props.messageToDisplay}
                            </div>
                        </div>
                    </div>
                    {!IsNullOrWhiteSpace(self.props.warningMessageToDisplay) && (
                        <div className="flex-container" style={{ marginLeft: "10px" }}>
                            <p className="label-error">{self.props.warningMessageToDisplay}</p>
                        </div>
                    )}
                    <div className="p-footer">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 columns text-right">
                                <div>
                                    <ButtonControl
                                        label={cacheStore.GetString("CancelLabel")}
                                        className="btn btn-default push-right-5"
                                        onClick={() => self.props.cancelCallback()}
                                    />
                                    <ButtonControl
                                        label={cacheStore.GetString("CloseLabel")}
                                        className="btn btn-default push-right-5"
                                        onClick={() => self.props.cancelCallback()}
                                    />
                                    <ButtonControl
                                        disabled={!isError}
                                        label={cacheStore.GetString("ContinueLabel")}
                                        className="btn btn-default push-right-5"
                                        onClick={() => self.props.continueCallback()}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            </div>
        );
    }
}

export { ImportPopupComponent };
